import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TranslateModule } from '@ngx-translate/core';
import { ReactiveFormsModule } from '@angular/forms';
import { PipesModule } from '../../common/pipes';
import { DirectivesModule } from '../../common/directives';
import { FieldErrorMessagesModule } from '../field-error-messages/field-error-messages.module';
import { CompartmentSelectComponent } from './compartment-select/compartment-select.component';

@NgModule({
  declarations: [CompartmentSelectComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatFormFieldModule,
    MatSelectModule,
    MatTooltipModule,
    ReactiveFormsModule,
    PipesModule,
    DirectivesModule,
    FieldErrorMessagesModule,
  ],
  exports: [CompartmentSelectComponent],
})
export class CompartmentSelectModule {}
